const UserStatus = [
    { id: 61,
     name: 'Active'
    },
    { id: 62,
     name: 'Inactive'
    }
]

const getUserStatusByName = (name) => {
    if(!name){
        return 1
    }
    const gender = UserStatus.filter(data => data.name === name.toUpperCase())

    if(gender.length === 0){
        return 1
    }

    return gender[0].id
}

const getUserStatusName = (id) => {
    if(!id){
        return 'NONE'
    }
    const gender = UserStatus.filter(data => data.id === id)
    return gender[0].name
}



export {
    UserStatus,
    getUserStatusName,
    getUserStatusByName
}
